//
import { queryList, addLog } from '../api';
const ssoError = {
  namespaced: true,
  state: {
    resp: {},
    total: null,
    addLog: null
  },
  mutations: {
  },
  actions: {
  }
}

export default ssoError



// WEBPACK FOOTER //
// ./src/page/sso/ssoError/store/ssoError.store.js